import React from 'react'
import tw, { styled } from 'twin.macro'
import { motion, AnimatePresence } from 'framer-motion'
import { useAtomValue } from 'jotai'
import { pathOr } from 'ramda'

import { currentProfileAtom } from '@/features/identity/atoms'
import { claimSpiritMachineAtom } from '@/features/spirit/atoms/claimSpiritMachineAtom'
import { claimSpiritStageAnimateAtom, claimSpiritStageAtom, ClaimSpiritStageEnum } from './atoms/claimSpiritStageAtom'

// SpiritsLeft
export const Left = styled(motion.div)`
  position: absolute;
  height: 100%;
`

// SripitsLeft: claimed status
export const LeftLineImg = styled.img`
  width: 9.9vw;
  max-width: 9.9vw;
  height: auto;
  position: absolute;
  top: 51vh;
  left: 31vw;
`

// userData
export const LeftWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-46%);
  left: 11vw;
`

export const LeftBody = styled.div`
  ${tw`font-secondary font-medium`}
  padding-top: 3.33vh;
  font-size: 1.56vw;
  color: #ffffff;
  text-align: left;
  line-height: 4.24vh;
  width: 19.11vw;
`

export const LeftFooter = styled.div`
  padding-top: 6.56vh;
`

export const UserData = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 2.52vh;
  width: 18.07vw;
`

export const Name = styled.span`
  ${tw`font-secondary`}
  font-size: 1.04vw;
  color: #ffffff;
`
export const Value = styled.span`
  ${tw`font-secondary font-bold`}
  font-size: 1.04vw;
  color: #21ffe6;
`

export const LinkInfo = styled.div`
  ${tw`font-primary`}
  font-size: 0.833vw;
  color: #ffffff;
`

// SripitsLeft: original status
export const LeftLineGrayImg = styled.img`
  width: 16.88vw;
  max-width: 16.88vw;
  height: auto;
  position: absolute;
  top: 51vh;
  left: 24vw;
`

export const TextWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 24vw;
  transform: translate(-100%, -40%);
  width: 12.5vw;
`

export const TextOne = styled.div`
  ${tw`font-secondary font-semibold`}
  font-size: 1.875vw;
  color: #ffffff;
`

export const TextTwo = styled.div`
  ${tw`font-primary`}
  font-size: 0.833vw;
  color: #b5b5b5;
  margin-top: 2.52vh;
  margin-bottom: 3.53vh;
`

export const TextThree = styled.div`
  ${tw`font-primary font-bold`}
  font-size: 0.833vw;
  color: #ffffff;
  line-height: 3.03vh;
`

const OriginalStatus: React.FC = () => {
  const variants = useAtomValue(claimSpiritStageAnimateAtom)
  return (
    <Left
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants.leftSection}
    >
      <LeftLineGrayImg
        src="/static/images/indexPage/Spirit/step01_img_line_left_normal.png"
        alt="line_left_normal"
      />
      <TextWrapper>
        <TextOne>SPIRIT</TextOne>
        <TextTwo>Your Spirit NFT Will Tell People:</TextTwo>
        <TextThree>WHO ARE YOU</TextThree>
        <TextThree>WHERE ARE YOU FROM</TextThree>
        <TextThree>WHERE ARE YOU GOING</TextThree>
      </TextWrapper>
    </Left>
  )
}

const StyledUserData: React.FC = () => {
  const machine = useAtomValue(claimSpiritMachineAtom)
  const profile = useAtomValue(currentProfileAtom)

  const displayName = profile.displayName
  const inWhiteList = pathOr(false, ['context', 'spirit', 'extra', 'is_whitelisted'], machine)
  const spiritNumber = pathOr('-', ['context', 'spiritCollection', '0', 'formattedNftId'], machine)
  const reputationLevel = pathOr('-', ['context', 'spirit', 'stats', 'reputation', 'level'], machine)

  return (
    <LeftWrapper>
      {profile.connected ? (
        <LeftBody>
          Hi,
          <span style={{color: '#27FFE2', margin: '0 0.25rem'}}>
            {` ${displayName}`}
          </span>
          !
          <br />
          {inWhiteList && (
            <>
              <span style={{color: '#27FFE2'}}>You have been whitelisted.</span>{' '}
              <br />
            </>
          )}
          You are the <br />
          <span style={{color: '#27FFE2'}}>{`#${spiritNumber} `}</span>
          awakened survivor.
        </LeftBody>
      ) : null}

      <LeftFooter>
        <UserData>
          <Name>Spirit Number</Name>
          <Value>{`#${spiritNumber}`}</Value>
        </UserData>
        <UserData>
          <Name>Your Level</Name>
          <Value>{`Lv. ${reputationLevel}`}</Value>
        </UserData>
      </LeftFooter>
    </LeftWrapper>
  )
}


const SpiritsLeft: React.FC = () => {
  const stage = useAtomValue(claimSpiritStageAtom)
  const variants = useAtomValue(claimSpiritStageAnimateAtom)
  return (
    <AnimatePresence mode="wait">
      {stage === ClaimSpiritStageEnum.claimed ? (
        <Left
          initial="initial"
          animate="animate"
          exit="exit"
          variants={variants.leftSection}
        >
          <LeftLineImg
            src="/static/images/indexPage/Spirit/step02_img_line_left_normal.png"
            alt="line_left_normal"
          />
          <StyledUserData />
        </Left>
      ) : (
        <OriginalStatus key="original" />
      )}
    </AnimatePresence>
  )
}

export default SpiritsLeft
